import { GET_CONVERSATIONS } from "../actions/ai.action";

const initialState = {
  conversations: [],
};

const aiReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONVERSATIONS:
      return {
        ...state,
        conversations: action.conversations,
      };
    default:
      return state;
  }
};

export default aiReducer;